import React, { useState } from 'react';
import ModalComponent from '../../../common-components/ModalComponent/ModalComponent';
import { useApi } from '../../../../hooks/useApi';
import { createPostTrackingSubscription } from '../../../../services/payment.service';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import '../styles/subscriptionPayment.scss';
import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserSetting } from '../../../../redux/user/userActions';
import SaralLoaderImage from '../../../common-components/SaralLoaderImage';
import { useStripeEnv } from '../../../../hooks/useStripeVersion';

const PostTrackingPayment = ({ isOpen, onClose, onPaymentSuccess }) => {
  const [clientSecret, setClientSecret] = useState();
  const { isLoading } = useApi(createPostTrackingSubscription, {
    onSuccess: (data) => {
      setClientSecret(data?.data?.clientSecret);
    },
  });
  const appearance = {
    theme: 'stripe',
    variables: { borderRadius: '4px' },
    rules: {
      '.TermsText': {
        display: 'none',
        visibility: 'hidden',
        height: 0,
        marginBottom: 10,
      },
      '.Label': { color: '#667085' },
      '.Input': { width: '100%' },
      '.p-TermsText': { display: 'none' },
    },
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <ModalComponent show={isOpen} onClose={onClose} width={500}>
      <div className="subscription-payment">
        <div className="subscription-payment-title">Get social listening add-on!</div>
        {isLoading || !clientSecret ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <SaralLoaderImage />
          </div>
        ) : (
          <Elements options={options} stripe={stripe}>
            <CheckoutForm onCancelClick={onClose} onPaymentSuccess={onPaymentSuccess} />
          </Elements>
        )}
      </div>
    </ModalComponent>
  );
};

const CheckoutForm = ({ onCancelClick, onPaymentSuccess }) => {
  const stripeEnv = useStripeEnv();
  const loadStripeFromEnv = loadStripe(stripeEnv);
  const stripe = useStripe(loadStripeFromEnv);
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);
  const dispatch = useDispatch();
  const userSettings = useSelector((state) => state.user.userSettings);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPayment(true);

    const data = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: `${window.location.origin.toString()}/dashboard/social`,
      },
    });

    const defaultError = 'An unexpected error occurred.';

    if (data?.error) {
      if (data.error?.type === 'card_error' || data.error?.type === 'validation_error') {
        console.log('Error');
        NotificationManager.error(data?.error?.message || defaultError, '', 1200);
      } else {
        NotificationManager.error(defaultError, '', 1200);
      }
    } else {
      onPaymentSuccess();
      dispatch(updateUserSetting({ ...userSettings, postTrackingStatus: true }));
    }
    setIsSubmittingPayment(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <div className="subscription-payment-buttons">
        <ButtonComponent variant="secondary" style={{ flex: 1 }} onClick={onCancelClick}>
          Cancel
        </ButtonComponent>
        <ButtonComponent type="submit" style={{ flex: 1 }} showLoading={isSubmittingPayment}>
          Get add-on
        </ButtonComponent>
      </div>
    </form>
  );
};

export default PostTrackingPayment;
